import React, { useState, useEffect, useRef } from 'react';
import Grid from '@mui/material/Grid2';
import 'leaflet/dist/leaflet.css';
import { Stack, Box, Typography } from '@mui/material';

import BarLine from '../components/bar_line';
import Heatmap from '../components/heatmap';
import MaxRiskH1Txt from '../item/max_risk_h1_txt';
import MapRiskMax from '../components/map_risk_rain';
import MapBsnTel from '../components/map_bsn_tel_base';
import CommonCard from '../item/common_card';
import VerticalBar from '../components/vertical_bar'
import Proggress from '../item/progress'
import HeaderSub from '../item/header_sub'
// import { useDataPolling, useDataFromS3 } from '../func/get_data_swr';
import { useDataFromS3 } from '../hooks/useDataFromS3';
import { SOIL_RISK_H1_LEGEND } from '../const/legend'
import { RISK_LEVEL_POINT, BSN_RISK_LEVEL_POINT, RISK_COLOR } from '../const/color'

import '../style/legend_risk.css';

import {
    setRiskColor,
} from '../func/color';
import {
    getAllByDateTimeWithAreaInfo, getTelIsCurrentVal, getMaxRiskH1ByCode,
    getMaxByDateTime, getTimeAry, getRankWithLimit,
    convertAreaDataFromMshData, getAllByCode
} from '../func/util'
import { DATA_TYPE } from '../const/user_config'
import { GRID_RANK } from '../const/grid'
import { LANDSLIDE_IMPACT_X_0_2000, FLOOD_IMPACT_X_0_15, LANDSLIDE_IMPACT_Y_2000, FLOOD_IMPACT_Y_15 } from '../const/annotations'
import { BASE_LAYER_LIST } from '../const/map_config'

import choropleth_area from '../data/area.json';
import choropleth_msh from '../data/msh.json';
import choropleth_flood from '../data/flood.json';
import choropleth_tel from '../data/tel.json';

const SummaryForCity = (props) => {
    const [selectLayer, setSelectLayer] = useState(
        BASE_LAYER_LIST.find(layer => layer.index.toString() === props.defaultUnit) || BASE_LAYER_LIST[1]
    );

    // 市町村、字、メッシュ、個別の選択をクリアするかしないかのフラグ
    const [shouldClearSelect, setShouldClearSelect] = useState(false)

    const [cityLandslideRiskH1, setCityLandslideRiskH1] = useState(null);
    const [areaLandslideRiskH1, setAreaLandslideRiskH1] = useState(null);
    const [mshLandslideRiskH1, setMshLandslideRiskH1] = useState(null);
    const [floodRiskH1, setFloodRiskH1] = useState(null);
    const [bsnRiskH1, setBsnRiskH1] = useState(null);
    const [telDataMaxVal, setTelDataMaxVal] = useState(null);
    const [landslideRiskMaxVal, setLandslideRiskMaxVal] = useState(null);
    const [landslideH1MaxVal, setLandslideH1MaxVal] = useState(null);
    const [landslideAllRankData, setLandslideAllRankData] = useState(null);
    const [landslideMaxRiskDatetime, setLandslideMaxRiskDatetime] = useState(null);
    const [landslideMaxH1Datetime, setLandslideMaxH1Datetime] = useState(null);
    const [floodMaxRiskDatetime, setFloodMaxRiskDatetime] = useState(null);
    const [floodMaxH1Datetime, setFloodMaxH1Datetime] = useState(null);
    const [floodRiskMaxVal, setFloodRiskMaxVal] = useState(null);
    const [dateArray, setDateArray] = useState(null);
    const [floodAllRankData, setFloodAllRankData] = useState(null);
    const [landslideAllRiskDatetime, setLandslideAllRiskDatetime] = useState(null);
    const [floodAllRiskDatetime, setFloodAllRiskDatetime] = useState(null);
    const [shouldFetch, setShouldFetch] = useState(false);
    const [shouldFetchTel, setShouldFetchTel] = useState(false);

    const prevDatetimeRef = useRef(null);
    const prevTelDatetimeRef = useRef(null);

    // // APIに含めるクエリパラメータの作成
    // const params = new URLSearchParams();
    // props.prefCode.forEach(code => params.append('pref_code', code));

    // 全データ再取得の要否を定期監視する
    const {
        data: datetimeLatest,
        loading: datetimeLatestLoading,
        error: datetimeLatestError,
    } = useDataFromS3(`api/get_datetime_latest`);

    // 10分おきの水位計の時刻を取得
    const {
        data: telDatetimeLatest,
    } = useDataFromS3(`api/get_tel_datetime_latest`);

    // サーバーの最終更新日時が変更されているか判定
    useEffect(() => {
        if (datetimeLatest && JSON.stringify(datetimeLatest) !== JSON.stringify(prevDatetimeRef.current)) {
            prevDatetimeRef.current = datetimeLatest;
            setShouldFetch(true); // dataが変わったらメインデータを取得
        } else {
            setShouldFetch(false); // dataが変わってないならメインデータを取得しない
        }
    }, [datetimeLatest]);

    useEffect(() => {
        if (telDatetimeLatest && JSON.stringify(telDatetimeLatest) !== JSON.stringify(prevTelDatetimeRef.current)) {
            prevTelDatetimeRef.current = telDatetimeLatest;
            setShouldFetchTel(true); // dataが変わったらメインデータを取得
        } else {
            setShouldFetchTel(false); // dataが変わってないならメインデータを取得しない
        }
    }, [telDatetimeLatest]);

    let tel_url = null
    let bsn_url = null
    let flood_url = null
    let landslide_msh_url = null
    if (shouldFetch) {
        bsn_url = `api/get_bsn_flood_impact`
        flood_url = `api/get_msh_flood_impact`
        landslide_msh_url = `api/get_msh_landslide_impact`
    }

    if (shouldFetchTel) {
        tel_url = `api/get_tel_mtr`
    }

    // 水位計データを取得
    const {
        data: telData,
        loading: telLoading,
        error: telError,
    } = useDataFromS3(tel_url);

    // 河川災害リスクを取得
    const {
        data: bsnFloodData,
        loading: bsnFloodLoading,
        error: bsnFloodError,
    } = useDataFromS3(bsn_url);

    // 浸水域リスクを取得
    const {
        data: mshFloodData,
        loading: mshFloodLoading,
        error: mshFloodError,
    } = useDataFromS3(flood_url);

    // 土砂災害リスクを取得
    const {
        data: mshLandslideData,
        loading: mshLandslideLoading,
        error: mshLandslideError,
    } = useDataFromS3(landslide_msh_url);

    const getRankData = (data, isOver, sliderValueRef, getLabelValue, getYValue) => {
        let rankData = data;
        if (isOver) {
            // 取得されたリスクの最大値を並べ替え（昇順/低い順）
            rankData.sort((a, b) => {
                if (a.max === b.max) {
                    return a.area_code - b.area_code;
                }
                return a.max - b.max
            })
        } else {
            // 取得されたリスクの最大値を並べ替え（降順/高い順）
            rankData.sort((a, b) => b.max - a.max)
            rankData.sort((a, b) => {
                if (a.max === b.max) {
                    return b.area_code - a.area_code;
                }
                return b.max - a.max
            })
        }

        // sliderValueに応じてリスクの最大値を並べ替え
        let series_ary = []
        let category_ary = []
        if (isOver) {
            // for (let i = sliderValue[1]; i > sliderValue[0] - 1; i--) {
            for (let i = sliderValueRef.current[1]; i > sliderValueRef.current[0] - 1; i--) {
                if (rankData.length > i) {
                    let str_time = ''
                    let time_index = 0
                    if (rankData[i].index_Val) {
                        str_time = `　${dateArray[rankData[i].index_Val]}`
                        time_index = rankData[i].index_Val
                    }
                    series_ary.push({
                        x: '',
                        y: rankData[i].max,
                        custom: {
                            area_name: rankData[i].area_name,
                            area_code: rankData[i].area_code,
                            area_lng: rankData[i].area_lng,
                            area_lat: rankData[i].area_lat,
                            str_time: str_time,
                            time_index: time_index,
                        }
                    })
                    category_ary.push(rankData[i].area_name)
                }
            }
        } else {
            rankData.map(item => {
                let str_time = ''
                let time_index = 0
                if (item.index_Val) {
                    str_time = `　(${dateArray[item.index_Val]})`
                    time_index = item.index_Val

                }
                series_ary.push({
                    x: '',
                    y: item.max,
                    custom: {
                        area_name: item.area_name,
                        area_code: item.area_code,
                        area_lng: item.area_lng,
                        area_lat: item.area_lat,
                        str_time: str_time,
                        time_index: time_index,
                    }
                })
                category_ary.push(item.area_name)
            })
        }
        return { rankData, series_ary, category_ary };
    }

    // ランキングクリック時の動作
    const verticalBarClickEvent = (clickedItem) => {
        props.setBsnMapCenter([clickedItem.custom.area_lng, clickedItem.custom.area_lat])
        props.setRiskMapCenter([clickedItem.custom.area_lng, clickedItem.custom.area_lat])
        setShouldClearSelect(false)
        setSelectLayer(BASE_LAYER_LIST[1])
        props.setSelectArea([clickedItem.custom.area_code])
        props.setSelectSubCity([]);
        props.setSelectMsh([]);
    }

    // ランキングのカラー（土砂）
    const getRankColor = (value, series, seriesIndex, dataPointIndex, w) => {
        return setRiskColor(RISK_LEVEL_POINT, value)
    }

    // ランキングのカラー（河川）
    const getBsnRankColor = (value, series, seriesIndex, dataPointIndex, w) => {
        return setRiskColor(BSN_RISK_LEVEL_POINT, value)
    }

    // ランキングのフォーマット
    const getFormat = (val, opts) => {
        const customData = opts.w.config.series[0].data[opts.dataPointIndex].custom;
        return `${val} ${customData.str_time}`;
    }

    // ランキングのラベルフォーマット
    const getLabelFormat = (value) => {
        const str = String(value);
        // 8文字以上は右側を省略
        if (str.length >= 8) {
            return str.slice(0, 7) + '...';
        }
        return '　'.repeat(8 - str.length) + str;
    }

    // ランキングのX軸ツールチップフォーマット
    const tooltipFormatX = (opts) => {
        return opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex].custom.area_name;
    }

    // ランキングのY軸ツールチップフォーマット
    const tooltipFormatY = (val) => {
        return String(val);
    }

    // ランキングのY軸ツールチップフォーマット
    const tooltipFormatCustom = (opts, areaNameAry, areaRiverNameAry) => {
        const label = opts.w.globals.labels[opts.dataPointIndex]; // y軸ラベル
        const value = opts.series[opts.seriesIndex][opts.dataPointIndex]; // 値
        const seriesName = opts.w.globals.seriesNames[opts.seriesIndex];

        return `<div style="padding: 4px 8px; font-size: 12px;">
                ${label} ${seriesName}: ${value}
                </div>`;
    }

    // 複合グラフのマーカー情報（土砂）
    const getPointsRisk = (date_ary, data_x) => {
        let points = []
        for (let i = 0; i < data_x.length; i++) {
            const color = setRiskColor(RISK_LEVEL_POINT, data_x[i])
            const point = {
                x: date_ary[i],
                y: data_x[i],
                marker: {
                    size: 4,
                    fillColor: color,
                    strokeColors: 'transparent',
                    strokeWidth: 0,
                    shape: "circle",
                },
            }
            points.push(point)
        }
        return points
    }

    // 複合グラフのマーカー情報（河川）
    const getPointsBsn = (date_ary, data_x) => {
        let points = []
        for (let i = 0; i < data_x.length; i++) {
            const color = setRiskColor(BSN_RISK_LEVEL_POINT, data_x[i])
            const point = {
                x: date_ary[i],
                y: data_x[i],
                marker: {
                    size: 4,
                    fillColor: color,
                    strokeColors: 'transparent',
                    strokeWidth: 0,
                    shape: "circle",
                },
            }
            points.push(point)
        }
        return points
    }

    // ヒートマップの数値表示変換処理
    const format = (val) => parseFloat(val).toFixed(0);

    const getHeatmapData = (date_ary, area_val_ary, isOver) => {
        let sorted_ary = []

        if (area_val_ary.length > 1) {
            if (isOver) {
                // 取得されたリスクの合計値の小さい順に並び替える（昇順/低い順）
                sorted_ary = [...area_val_ary].sort((a, b) => {
                    const maxA = Math.max(...a.risk_val.slice(6));
                    const maxB = Math.max(...b.risk_val.slice(6));
                    if (maxA === maxB) {
                        // risk_val が同じなら area_code の昇順でソート
                        return a.area_code - b.area_code;
                    }
                    return maxA - maxB; // 昇順（小さい順）
                });
            } else {
                // 取得されたリスクの合計値の大きい順に並び替える（降順/高い順）
                sorted_ary = [...area_val_ary].sort((a, b) => {
                    const maxA = Math.max(...a.risk_val.slice(6));
                    const maxB = Math.max(...b.risk_val.slice(6));
                    if (maxA === maxB) {
                        // risk_val が同じなら area_code の降順でソート
                        return b.area_code - a.area_code;
                    }
                    return maxB - maxA; // 降順（大きい順）
                });
            }
        } else {
            // 1件だけならそのまま渡す
            sorted_ary = area_val_ary
        }

        const chartData = sorted_ary.map((item) => ({
            name: item.area_name,
            data: item.risk_val.map((val, i) => ({
                x: date_ary[i],
                // 0だとチャートの仕様上、色がつかないため加工
                y: val === 0 ? 0.0001 : val,
                originalValue: val,
                area_code: item.area_code,
                area_lat: item.area_lat,
                area_lng: item.area_lng
            }))
        }));
        return chartData;
    }

    // ヒートマップクリック時の動作
    const heetmapClickEvent = (clickedItem) => {
        const areaCode = clickedItem.area_code;
        props.setBsnMapCenter([clickedItem.area_lng, clickedItem.area_lat])
        props.setRiskMapCenter([clickedItem.area_lng, clickedItem.area_lat])
        setShouldClearSelect(false)
        setSelectLayer(BASE_LAYER_LIST.find(layer => layer.index.toString() === props.defaultUnit) || BASE_LAYER_LIST[1])
        props.setSelectArea([areaCode])
        props.setSelectSubCity([]);
        props.setSelectMsh([]);
        props.setSelectBsn([]);
    }

    // ヒートマップのカラー
    const colorScale = (dataType) => {
        return {
            ranges: dataType === DATA_TYPE.FLOOD_IMPACT ? [
                { from: 0, to: 1.99, name: 'レベル0', color: RISK_COLOR.LEVEL_1.color },
                { from: 2, to: 4.99, name: 'レベル1', color: RISK_COLOR.LEVEL_2.color },
                { from: 5, to: 7.99, name: 'レベル2', color: RISK_COLOR.LEVEL_3.color },
                { from: 8, to: 14.99, name: 'レベル3', color: RISK_COLOR.LEVEL_4.color },
                { from: 15, to: 100, name: 'レベル4', color: RISK_COLOR.LEVEL_5.color },
            ] : [
                { from: 0, to: 299.99, name: 'レベル0', color: RISK_COLOR.LEVEL_1.color },
                { from: 300, to: 599.99, name: 'レベル1', color: RISK_COLOR.LEVEL_2.color },
                { from: 600, to: 999.99, name: 'レベル2', color: RISK_COLOR.LEVEL_3.color },
                { from: 1000, to: 1999.99, name: 'レベル3', color: RISK_COLOR.LEVEL_4.color },
                { from: 2000, to: 20000, name: 'レベル4', color: RISK_COLOR.LEVEL_5.color },
            ]
        }
    }

    // データ整備用のパラメータを取得
    const getParams = (keyAry, keyName = '') => {

        const features_area = choropleth_area.features
        const features_msh = choropleth_msh.features
        const features_flood = choropleth_flood.features
        const features_tel = choropleth_tel.features

        if (keyName === '') {
            const ids = features_flood
                .filter(feature => {
                    const codes = feature.properties.bsn_code
                        .split(",")
                        .map(code => Number(code.trim())); // 文字列を数値に変換

                    // bsn_codeの中にtargetCodesのどれかが含まれていればOK
                    return codes.some(code => keyAry.includes(code));
                })
                .map(feature => feature.properties.id);
            //該当するメッシュコードの配列
            keyAry = ids
            keyName = 'id'
        }

        // メッシュデータ取得
        const mastreMshFeatures = features_msh.filter(f =>
            keyAry.includes(f.properties[keyName])
        );

        // メッシュデータの properties.area_code を配列で取得(これが対象の字コード)
        const area_code_ary = [...new Set(mastreMshFeatures.map(feature => feature.properties.area_code))];
        // 字のマスターデータ取得
        const mastreAreaFeatures = features_area.filter(f =>
            area_code_ary.includes(f.properties.id)
        );
        // メッシュデータの properties.id を配列で取得(これが対象のメッシュコード)
        const msh_code_ary = mastreMshFeatures.map(feature => feature.properties.id);
        // bsnデータ取得
        const mastreFloodFeatures = features_flood.filter(f =>
            msh_code_ary.includes(f.properties.id)
        );
        // bsnデータの properties.id を配列で取得(これが対象のbsnコード)
        const bsn_code_ary = [...new Set(mastreFloodFeatures.map(
            feature => Number(feature.properties.bsn_code)).filter(n => !isNaN(n)))];
        // bsnデータの properties.id を配列で取得(これが対象のfloodコード)
        const flood_code_ary = [...new Set(mastreFloodFeatures.map(feature => feature.properties.id))];

        // telデータ取得
        const mastreTelFeatures = features_tel.filter(f =>
            bsn_code_ary.includes(f.properties.bsn_code)
        );
        // telデータの properties.id を配列で取得(これが対象のtelコード)
        const tel_code_ary = [...new Set(mastreTelFeatures.map(feature => feature.properties.id))];
        return {
            msh_code_ary, area_code_ary, bsn_code_ary, tel_code_ary, flood_code_ary,
            mastreMshFeatures, mastreAreaFeatures
        };
    }

    useEffect(() => {
        // ローディング開始
        props.setReady(prev => {
            const updated = Object.fromEntries(
                Object.keys(prev).map(key => [key, false])
            );
            return updated;
        });
        const fetchData = async () => {
            let params_obj = {}

            let msh_landslide_risk_h1_all_datetime = []
            let area_landslide_risk_h1_all_datetime = []
            let city_landslide_risk_h1_all_datetime = []

            let city_landslide_risk_h1_max = []
            let area_landslide_risk_h1_max = []
            let msh_landslide_risk_h1_max = []

            let flood_risk_h1_max = []
            let bsn_risk_h1_max = []
            let tel_data_max = []

            let msh_flood_risk_h1_all_datetime = []
            let bsn_risk_h1_all_datetime = []
            let area_flood_risk_h1_all_datetime = []
            let landslide_risk_rank = []
            let landslide_risk_maxVal = null
            let landslide_h1_maxVal = null
            let flood_risk_rank = []
            let flood_risk_maxVal = null
            let date_ary = []
            let landslide_risk_max_datetime = []
            let landslide_h1_max_datetime = []
            let flood_risk_max_datetime = []
            let flood_h1_max_datetime = []
            let landslide_risk_all_datetime = []
            let flood_risk_all_datetime = []

            if (props.selectBsn && Array.isArray(props.selectBsn)
                && props.selectBsn.length > 0) {
                params_obj = getParams(props.selectBsn, '')

            } else if (props.selectArea && Array.isArray(props.selectArea)
                && props.selectArea.length > 0) {
                params_obj = getParams(props.selectArea, 'area_code')

            } else if (props.selectMsh && Array.isArray(props.selectMsh)
                && props.selectMsh.length > 0) {
                params_obj = getParams(props.selectMsh, 'id')

            } else if (props.selectSubCity && Array.isArray(props.selectSubCity)
                && props.selectSubCity.length > 0) {
                params_obj = getParams(props.selectSubCity, 'city_code')

            } else {
                params_obj = getParams(props.selectCitys, 'city_code')
            }

            // if (area_code_ary.length > 0) {
            if (Object.keys(params_obj).length > 0) {
                // 日時の配列を取得
                date_ary = getTimeAry(datetimeLatest, props.h6Switch)

                //// メッシュコードごとのリスクと雨量のオブジェクト配列を取得
                // [{ code: 503021111（メッシュコード）, 
                // risk_val: [3, 2, 3, 2, 3, 4, 8, 10, 14, 24], 
                // h1_val: [1, 1, 1, 1, 1, 1, 9, 5, 6, 7],}, ..............]
                msh_landslide_risk_h1_all_datetime = getAllByCode(params_obj.msh_code_ary, mshLandslideData, props.h6Switch)
                // msh_landslide_risk_h1_all_datetime = mshLandslideData
                if (msh_landslide_risk_h1_all_datetime.length > 0) {
                    //// 字コードごとのリスクと雨量のオブジェクト配列を取得
                    // [{ code: 401010010（字コード）, 
                    // risk_val: [3, 2, 3, 2, 3, 4, 8, 10, 14, 24], 
                    // h1_val: [1, 1, 1, 1, 1, 1, 9, 5, 6, 7],}, ..............]
                    area_landslide_risk_h1_all_datetime = convertAreaDataFromMshData(params_obj.mastreMshFeatures, msh_landslide_risk_h1_all_datetime)
                    // 地図の字レイヤー用のデータ
                    area_landslide_risk_h1_max = getMaxRiskH1ByCode(area_landslide_risk_h1_all_datetime, 0)
                    // 地図の市町村レイヤー用のデータ
                    city_landslide_risk_h1_max = getMaxRiskH1ByCode(area_landslide_risk_h1_all_datetime, 5)
                    // 地図のメッシュレイヤー用のデータ
                    msh_landslide_risk_h1_max = getMaxRiskH1ByCode(msh_landslide_risk_h1_all_datetime, 0)
                    // 土砂のヒートマップ
                    landslide_risk_all_datetime = getAllByDateTimeWithAreaInfo(params_obj.mastreAreaFeatures, area_landslide_risk_h1_all_datetime);
                    // 土砂のランキング用のデータ
                    landslide_risk_rank = getRankWithLimit(landslide_risk_all_datetime, 200)
                    // 土砂のリスク最大値用のデータ
                    landslide_risk_maxVal = landslide_risk_rank[0].max
                    // 土砂の複合グラフのラインチャート用のデータ
                    landslide_risk_max_datetime = getMaxByDateTime(area_landslide_risk_h1_all_datetime, 'risk_val');
                    // 複合グラフのbarチャート用のデータ
                    landslide_h1_max_datetime = getMaxByDateTime(area_landslide_risk_h1_all_datetime, 'h1_val');
                    // 土砂の1時間雨量最大値用のデータ
                    landslide_h1_maxVal = Math.max(...landslide_h1_max_datetime.slice(6));
                }
                //// メッシュコードごとの河川リスクと雨量のオブジェクト配列を取得
                // [{ code: 503021111（メッシュコード）, 
                // risk_val: [3, 2, 3, 2, 3, 4, 8, 10, 14, 24], 
                // h1_val: [1, 1, 1, 1, 1, 1, 9, 5, 6, 7],}, ..............]
                msh_flood_risk_h1_all_datetime = getAllByCode(params_obj.flood_code_ary, mshFloodData, props.h6Switch)
                bsn_risk_h1_all_datetime = getAllByCode(params_obj.bsn_code_ary, bsnFloodData, props.h6Switch)
                tel_data_max = getTelIsCurrentVal(params_obj.tel_code_ary, telData)

                if (msh_flood_risk_h1_all_datetime.length > 0) {
                    //// 字コードごとのリスクと雨量のオブジェクト配列を取得
                    // [{ code: 401010010（字コード）, 
                    // risk_val: [3, 2, 3, 2, 3, 4, 8, 10, 14, 24], 
                    // h1_val: [1, 1, 1, 1, 1, 1, 9, 5, 6, 7],}, ..............]
                    area_flood_risk_h1_all_datetime = convertAreaDataFromMshData(params_obj.mastreMshFeatures, msh_flood_risk_h1_all_datetime)
                    // 地図の浸水区域レイヤー用のデータ
                    flood_risk_h1_max = getMaxRiskH1ByCode(msh_flood_risk_h1_all_datetime, 0)
                    // 地図の浸水区域レイヤー用のデータ
                    bsn_risk_h1_max = getMaxRiskH1ByCode(bsn_risk_h1_all_datetime, 0)
                    // 河川のヒートマップ用のデータ
                    flood_risk_all_datetime = getAllByDateTimeWithAreaInfo(params_obj.mastreAreaFeatures, area_flood_risk_h1_all_datetime);
                    // 河川のランキング用のデータ
                    flood_risk_rank = getRankWithLimit(flood_risk_all_datetime, 200)
                    // 河川のリスク最大値用のデータ
                    flood_risk_maxVal = flood_risk_rank[0].max
                    // 河川の複合グラフのラインチャート用のデータ
                    flood_risk_max_datetime = getMaxByDateTime(area_flood_risk_h1_all_datetime, 'risk_val');
                    // 複合グラフのbarチャート用のデータ
                    flood_h1_max_datetime = getMaxByDateTime(area_flood_risk_h1_all_datetime, 'h1_val');
                }
            }
            setCityLandslideRiskH1(city_landslide_risk_h1_max.length > 0 ? city_landslide_risk_h1_max : null)
            setAreaLandslideRiskH1(area_landslide_risk_h1_max.length > 0 ? area_landslide_risk_h1_max : null)
            setMshLandslideRiskH1(msh_landslide_risk_h1_max.length > 0 ? msh_landslide_risk_h1_max : null)
            setFloodRiskH1(flood_risk_h1_max.length > 0 ? flood_risk_h1_max : null)
            setBsnRiskH1(bsn_risk_h1_max.length > 0 ? bsn_risk_h1_max : null)
            setTelDataMaxVal(tel_data_max.length > 0 ? tel_data_max : null)

            setLandslideAllRankData(landslide_risk_rank.length > 0 ? landslide_risk_rank : null)
            setFloodAllRankData(flood_risk_rank.length > 0 ? flood_risk_rank : null)

            setLandslideRiskMaxVal(landslide_risk_maxVal)
            setLandslideH1MaxVal(landslide_h1_maxVal)
            setFloodRiskMaxVal(flood_risk_maxVal)

            setDateArray(date_ary.length > 0 ? date_ary : null)
            setLandslideMaxRiskDatetime(landslide_risk_max_datetime.length > 0 ? landslide_risk_max_datetime : null)
            setLandslideMaxH1Datetime(landslide_h1_max_datetime.length > 0 ? landslide_h1_max_datetime : null)
            setFloodMaxRiskDatetime(flood_risk_max_datetime.length > 0 ? flood_risk_max_datetime : null)
            setFloodMaxH1Datetime(flood_h1_max_datetime.length > 0 ? flood_h1_max_datetime : null)

            setLandslideAllRiskDatetime(landslide_risk_all_datetime.length > 0 ? landslide_risk_all_datetime : null)
            setFloodAllRiskDatetime(flood_risk_all_datetime.length > 0 ? flood_risk_all_datetime : null)
        };
        if (datetimeLatest
            && telData
            && bsnFloodData
            && mshLandslideData
            && mshFloodData) {
            fetchData();
        }
    }, [datetimeLatest,
        telData,
        bsnFloodData,
        mshLandslideData,
        mshFloodData,
        props.selectCitys, props.selectSubCity,
        props.selectArea, props.selectMsh, props.selectBsn, props.h6Switch
    ]);

    if ((datetimeLatestError && datetimeLatestError.message.includes("Received HTML"))
        || (telError && telError.message.includes("Received HTML"))
        || (bsnFloodError && bsnFloodError.message.includes("Received HTML"))
        || (mshLandslideError && mshLandslideError.message.includes("Received HTML"))
        || (mshFloodError && mshFloodError.message.includes("Received HTML"))
        || datetimeLatestLoading || datetimeLatest === undefined
        || telLoading || telData === undefined
        || bsnFloodLoading || bsnFloodData === undefined
        || mshFloodLoading || mshFloodData === undefined
        || mshLandslideLoading || mshLandslideData === undefined
    ) {
        // Loading表示
        return <Proggress />
    }

    if (datetimeLatestError
        || telError
        || bsnFloodError
        || mshLandslideError
        || mshFloodError
    ) {
        return (
            <>
                <Typography
                    sx={{
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        color: 'white',
                    }}
                >
                    申し訳ございません、データ取得に失敗しました。
                </Typography>
                <Typography
                    sx={{
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        color: 'white',
                    }}
                >
                    恐れ入りますが、しばらく時間をおいてから再度お試しください。
                </Typography>
            </>
        )
    }

    return (
        <>
            <Box
                sx={{
                    height: { xs: '100%', sm: 'calc(100dvh - 61px)' }, // 親が高さを持つ
                    boxSizing: 'border-box',
                }}
            >
                <HeaderSub
                    pageTitle={""}
                    dateTime={datetimeLatest[6]}
                />
                <Grid container
                    spacing={0}
                    columns={12}
                    // height={'100%'}
                    sx={{ height: '100%', width: '100%', padding: 0, m: 0 }} // Grid全体の高さ100%

                >
                    <Grid size={{ xs: 12, sm: 7, md: 4 }}>
                        <CommonCard
                            child={
                                <MapRiskMax
                                    selectSubCity={props.selectSubCity}
                                    setSelectSubCity={props.setSelectSubCity}
                                    selectArea={props.selectArea}
                                    setSelectArea={props.setSelectArea}
                                    selectMsh={props.selectMsh}
                                    setSelectMsh={props.setSelectMsh}
                                    selectBsn={props.selectBsn}
                                    setSelectBsn={props.setSelectBsn}
                                    selectCitys={props.selectCitys}
                                    cityLandslideRiskH1={cityLandslideRiskH1}
                                    areaLandslideRiskH1={areaLandslideRiskH1}
                                    mshLandslideRiskH1={mshLandslideRiskH1}
                                    riskMapZoom={props.riskMapZoom}
                                    riskMapCenter={props.riskMapCenter}
                                    selectLayer={selectLayer}
                                    setSelectLayer={setSelectLayer}
                                    shouldClearSelect={shouldClearSelect}
                                    setShouldClearSelect={setShouldClearSelect}
                                    tooltipLabel={"避難推奨レベル（土砂）"}
                                    legendLabel={"避難推奨レベル（土砂）"}
                                />
                            }
                            title={"避難推奨レベル（土砂）"}
                            xsHeight="300px"
                            // 「18px」ヘッダーの半分、「9px」時刻表示の半分、
                            // 「8px」ページ全体のパディング分、「31px」タイトル分
                            // height='calc(50dvh - 18px - 17px - 8px - 31px)'
                            height='calc(50dvh - 18px - 9px - 8px - 31px)'
                        // handleReset={handleAreaReset}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 5, md: 3 }}>
                        <Stack spacing={0} height={{ xs: '100%', sm: 'calc(50dvh - 18px - 9px - 8px)' }} >
                            {/* リスク・雨量最大値 */}
                            <MaxRiskH1Txt
                                titleRisk={"避難推奨レベル（土砂・最大）"}
                                titleH1={"最大1時間雨量"}
                                riskMaxVal={landslideRiskMaxVal}
                                h1MaxVal={landslideH1MaxVal}
                                setColor={setRiskColor}
                                levelPoint={RISK_LEVEL_POINT}
                                height={'40px)'}
                            />
                            {/* 避難推奨レベル（土砂）ランキング */}
                            <CommonCard
                                child={
                                    <VerticalBar
                                        distance={10}
                                        limitVal={2000}
                                        annotations={LANDSLIDE_IMPACT_X_0_2000}
                                        grid={GRID_RANK}
                                        allRankData={landslideAllRankData}
                                        dateArray={dateArray}
                                        getRankData={getRankData}
                                        plusValue={10}
                                        verticalBarClickEvent={verticalBarClickEvent}
                                        getRankColor={getRankColor}
                                        fontSize={'12px'}
                                        getFormat={getFormat}
                                        maxWidth={160}
                                        getLabelFormat={getLabelFormat}
                                        enabled={true}
                                        tooltipFormatX={tooltipFormatX}
                                        tooltipFormatY={tooltipFormatY}
                                        tooltipFormatCustom={tooltipFormatCustom}
                                        height={'100%'}
                                        isReadyKey={['rank_soil']}
                                        isReadyFlg={props.isReady.rank_soil}
                                        setReady={props.setReady}
                                    />
                                }
                                title={"避難推奨レベル（土砂）ランキング"}
                                xsHeight="200px"
                                // height='calc(50dvh - 18px - 17px - 8px - 31px - 45px - 31px)'
                                height='calc(50dvh - 18px - 9px - 8px - 31px - 45px - 31px)'
                            />
                        </Stack>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 5 }}>
                        <Stack spacing={0} height={{ xs: '100%', sm: 'calc(50dvh - 18px - 9px - 8px)' }}>
                            {/* 1時間雨量 */}
                            <CommonCard
                                child={
                                    <>
                                        {SOIL_RISK_H1_LEGEND()}
                                        <BarLine
                                            annotations={LANDSLIDE_IMPACT_Y_2000}
                                            limitVal={2000}
                                            dateArray={dateArray}
                                            xDatetime={landslideMaxRiskDatetime}
                                            yDatetime={landslideMaxH1Datetime}
                                            getPoints={getPointsRisk}
                                            name={'土砂災害発生リスク'}
                                            seriesNameX={'避難推奨レベル'}
                                            seriesNameY={'1時間雨量'}
                                            colors={['#5c9fed', '#5c9fed']}
                                            strokeColors={['#5c9fed', 'transparent']}
                                            shared={false}
                                            intersect={true}
                                            format={format}
                                            bottom={0}
                                            isReadyKey={['bar_line_soil']}
                                            isReadyFlg={props.isReady.bar_line_soil}
                                            setReady={props.setReady}
                                            chooseNum={6}
                                        />
                                    </>
                                }
                                title={"日時ごとの1時間雨量、避難推奨レベル（土砂）"}
                                xsHeight="200px"
                                // height='50%'
                                // height='calc(25dvh - 19px)'
                                // height='calc(25dvh - 8px - 31px)'
                                height='calc(25dvh - 9px - 4px - 4px - 31px)'
                            />
                            {/* ヒートマップ */}
                            <CommonCard
                                child={
                                    <Heatmap
                                        distance={5}
                                        limitDataCount={200}
                                        dataType={DATA_TYPE.LANDSLIDE_IMPACT}
                                        defaultUnit={props.defaultUnit}
                                        dateArray={dateArray}
                                        allRiskDatetime={landslideAllRiskDatetime}
                                        getHeatmapData={getHeatmapData}
                                        heetmapClickEvent={heetmapClickEvent}
                                        colorScale={colorScale}
                                        isReadyKey={['heatmap_soil']}
                                        isReadyFlg={props.isReady.heatmap_soil}
                                        setReady={props.setReady}
                                    />}
                                title={"字、日時ごとの避難推奨レベル（土砂）"}
                                xsHeight="200px"
                                height='calc(25dvh - 9px - 4px - 4px - 31px)'
                            />
                        </Stack>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 7, md: 4 }}>
                        <CommonCard
                            child={
                                <MapBsnTel
                                    mapZoom={props.riskMapZoom}
                                    mapCenter={props.riskMapCenter}
                                    selectSubCity={props.selectSubCity}
                                    setSelectSubCity={props.setSelectSubCity}
                                    selectArea={props.selectArea}
                                    setSelectArea={props.setSelectArea}
                                    selectMsh={props.selectMsh}
                                    setSelectMsh={props.setSelectMsh}
                                    selectBsn={props.selectBsn}
                                    setSelectBsn={props.setSelectBsn}
                                    selectCitys={props.selectCitys}
                                    // floodUrl={`api/get_msh_max_flood_impact`}
                                    // telUrl={`api/get_tel_mtr_current`}
                                    bsnData={bsnRiskH1}
                                    floodData={floodRiskH1}
                                    telData={telDataMaxVal}

                                    // getPolygonColor={setRiskColor}
                                    baseLayerIndex={1}
                                    bsnMapZoom={props.bsnMapZoom}
                                    setBsnMapZoom={props.setBsnMapZoom}
                                    bsnMapCenter={props.bsnMapCenter}
                                    setBsnMapCenter={props.setBsnMapCenter}
                                    h6Switch={props.h6Switch}
                                />
                            }
                            title={"避難推奨レベル（河川）"}
                            xsHeight="300px"
                            // height='calc(50dvh - 18px - 17px - 8px - 31px)'
                            height='calc(50dvh - 18px - 9px - 8px - 31px)'
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 5, md: 3 }}>
                        <Stack spacing={0} height={{ xs: '100%', sm: 'calc(50dvh - 18px - 9px - 8px)' }} >
                            {/* リスク */}
                            <MaxRiskH1Txt
                                titleRisk={"避難推奨レベル（河川・最大）"}
                                riskMaxVal={floodRiskMaxVal}
                                setColor={setRiskColor}
                                levelPoint={BSN_RISK_LEVEL_POINT}
                            />
                            {/* 避難推奨レベル（河川）ランキング */}
                            <CommonCard
                                child={
                                    <VerticalBar
                                        distance={10}
                                        limitVal={15}
                                        annotations={FLOOD_IMPACT_X_0_15}
                                        grid={GRID_RANK}
                                        allRankData={floodAllRankData}
                                        dateArray={dateArray}
                                        getRankData={getRankData}
                                        plusValue={10}
                                        verticalBarClickEvent={verticalBarClickEvent}
                                        getRankColor={getBsnRankColor}
                                        fontSize={'12px'}
                                        getFormat={getFormat}
                                        maxWidth={160}
                                        getLabelFormat={getLabelFormat}
                                        enabled={true}
                                        tooltipFormatX={tooltipFormatX}
                                        tooltipFormatY={tooltipFormatY}
                                        tooltipFormatCustom={tooltipFormatCustom}
                                        height={'100%'}
                                        isReadyKey={['rank_river']}
                                        isReadyFlg={props.isReady.rank_river}
                                        setReady={props.setReady}
                                    />
                                }
                                title={"避難推奨レベル（河川）ランキング"}
                                xsHeight="200px"
                                // height='calc(50dvh - 18px - 17px - 8px - 31px - 45px - 31px)'
                                height='calc(50dvh - 18px - 9px - 8px - 31px - 45px - 31px)'
                            />
                        </Stack>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 5 }}>
                        <Stack height={{ xs: '100%', sm: 'calc(50dvh - 18px - 9px - 8px)' }}>
                            {/* 1時間雨量 */}
                            <CommonCard
                                child={
                                    <>
                                        {SOIL_RISK_H1_LEGEND()}
                                        <BarLine
                                            annotations={FLOOD_IMPACT_Y_15}
                                            limitVal={15}
                                            dateArray={dateArray}
                                            xDatetime={floodMaxRiskDatetime}
                                            yDatetime={landslideMaxH1Datetime}
                                            getPoints={getPointsBsn}
                                            name={'土砂災害発生リスク'}
                                            seriesNameX={'避難推奨レベル'}
                                            seriesNameY={'1時間雨量'}
                                            colors={['#5c9fed', '#5c9fed']}
                                            strokeColors={['#5c9fed', 'transparent']}
                                            shared={false}
                                            intersect={true}
                                            format={format}
                                            bottom={0}
                                            isReadyKey={['bar_line_river']}
                                            isReadyFlg={props.isReady.bar_line_river}
                                            setReady={props.setReady}
                                        />
                                    </>
                                }
                                title={"日時ごとの避難推奨レベル（河川）"}
                                xsHeight="200px"
                                height='calc(25dvh - 9px - 4px - 4px - 31px)'
                            />
                            {/* ヒートマップ */}
                            <CommonCard
                                child={
                                    <Heatmap
                                        distance={5}
                                        limitDataCount={200}
                                        dataType={DATA_TYPE.FLOOD_IMPACT}
                                        defaultUnit={props.defaultUnit}
                                        dateArray={dateArray}
                                        allRiskDatetime={floodAllRiskDatetime}
                                        getHeatmapData={getHeatmapData}
                                        heetmapClickEvent={heetmapClickEvent}
                                        colorScale={colorScale}
                                        isReadyKey={['heatmap_river']}
                                        isReadyFlg={props.isReady.heatmap_river}
                                        setReady={props.setReady}
                                    />}
                                title={"字、日時ごとの避難推奨レベル（河川）"}
                                xsHeight="200px"
                                height='calc(25dvh - 9px - 4px - 4px - 31px)'
                            />
                        </Stack>
                    </Grid>
                </Grid>
            </Box>
        </>
    )
}
export default SummaryForCity;